import React from 'react';
import PropTypes from 'prop-types';
import { useConfig, useGetPortalPath } from '@mulesoft/exchange-react-hooks';
import { SidebarItem, SidebarTitle } from '@mulesoft/exchange-ui-components';
import { Sidebar as GenericAssetPortalSidebar } from '@mulesoft/exchange-ui-portals-common';

const AssetPortalSidebar = ({ portalConfiguration, ...props }) => {
  const getPortalPath = useGetPortalPath();
  const config = useConfig();
  const currentKey = '$$current';
  const orderKey = '$$order';
  const itemsByTitle = portalConfiguration
    .sections({
      ...props,
      config
    })
    .filter((item) => item)
    .reduce(
      (accum, current, index) => {
        const currentTitle =
          current.title ?? accum[currentKey] ?? 'Other details';
        const orderedTitles = accum[orderKey].some(
          (key) => key === currentTitle
        )
          ? accum[orderKey]
          : [...(accum[orderKey] ?? []), currentTitle];

        if (typeof current === 'object' && 'title' in current) {
          return {
            ...accum,
            [currentKey]: current.title,
            [orderKey]: orderedTitles
          };
        }

        if (React.isValidElement(current)) {
          return {
            ...accum,
            [currentTitle]: [
              ...(accum[currentTitle] ?? []),
              <React.Fragment key={index}>{current}</React.Fragment>
            ],
            [orderKey]: orderedTitles
          };
        }

        if (typeof current === 'object' && 'to' in current) {
          return {
            ...accum,
            [currentTitle]: [
              ...(accum[currentTitle] ?? []),
              <SidebarItem to={getPortalPath(current.to)} key={index}>
                {current.label}
              </SidebarItem>
            ],
            [orderKey]: orderedTitles
          };
        }

        return accum;
      },
      {
        [orderKey]: []
      }
    );
  const items = itemsByTitle[orderKey].reduce((accum, title) => {
    return [
      ...accum,
      <SidebarTitle key={title}>{title}</SidebarTitle>,
      ...(itemsByTitle[title] ?? [])
    ];
  }, []);

  const renderNavigation = () => items;

  return (
    <GenericAssetPortalSidebar {...props} renderNavigation={renderNavigation} />
  );
};

AssetPortalSidebar.propTypes = {
  portalConfiguration: PropTypes.object
};

export default AssetPortalSidebar;
